/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth


// (function (Drupal) { // UNCOMMENT IF DRUPAL.
//
//   Drupal.behaviors.mainMenu = {
//     attach: function (context) {

(function () { // REMOVE IF DRUPAL.

  'use strict';

  // Use context instead of document IF DRUPAL.
  var notice = document.querySelector('#artsuw-site-notice');


  var resizeTimeout;
  positionNeighbor(notice);

  function resizeThrottler() {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function () {
        resizeTimeout = null;
        positionNeighbor(notice);


        // The actualResizeHandler will execute at a rate of 15fps
      }, 66);
    }
  }

  function positionNeighbor(element){
    var ele_dims = element.getBoundingClientRect();
    element.parentNode.querySelector('.dialog-off-canvas-main-canvas').style.transform = 'translateY(' + ele_dims.height + 'px)';
  }

  if(notice){
    positionNeighbor(notice);
    window.addEventListener("resize", resizeThrottler, false);
  }

})(); // REMOVE IF DRUPAL.

// })(Drupal); // UNCOMMENT IF DRUPAL.
